export default __webpack_public_path__ + "static/media/ponto_2.6cc42fd6.svg";